import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "react-bootstrap";

/**
 * DoctorLetterModal component
 * A modal for displaying the doctor's letter with a title and content.
 *
 * @returns {JSX.Element} The rendered modal component.
 */
export function DoctorLetterModal({ isOpen, toggle, title, children }) {
  return (
    <Modal className="doctor-letter-modal" show={isOpen} onHide={toggle} centered scrollable>
      <ModalHeader closeButton>
        <strong>{title}</strong>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

DoctorLetterModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
